class NovaMainSearchForm extends HTMLElement {
  constructor() {
    super()

    this.form = this.querySelector('form')
    this.clearButton = this.querySelector('.main-search-clear-button')
    this.searchInput = this.querySelector('.main-search__input')

    this.handleClearTerms = this.handleClearTerms.bind(this)
  }

  connectedCallback() {
    this.clearButton.addEventListener('click', this.handleClearTerms)
  }

  handleClearTerms(event) {
    event.preventDefault()

    this.searchInput.value = ''
    setTimeout(() => {
      this.searchInput.focus()
    }, 300)
  }
}

customElements.define('nova-main-search-form', NovaMainSearchForm)
